var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位",
      "prop": "sign_post"
    }
  }, [_c('setPost', {
    ref: "setPost",
    attrs: {
      "type": "checkbox",
      "accordion": true,
      "post_ids_prop": _vm.from.sign_post
    },
    on: {
      "commit": _vm.monitorCheckboxChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同模板",
      "prop": "sign_template"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "width": "92%"
    },
    model: {
      value: (_vm.from.sign_template),
      callback: function($$v) {
        _vm.$set(_vm.from, "sign_template", $$v)
      },
      expression: "from.sign_template"
    }
  }, _vm._l((_vm.templateList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.template_name) + "\n\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起止时间",
      "prop": "start_stop_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.from.start_stop_date),
      callback: function($$v) {
        _vm.$set(_vm.from, "start_stop_date", $$v)
      },
      expression: "from.start_stop_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "state"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "92%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.from.state),
      callback: function($$v) {
        _vm.$set(_vm.from, "state", $$v)
      },
      expression: "from.state"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "已生效",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未生效",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id === null || _vm.from.id === ''),
      expression: "from.id === null || from.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Add()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id != null && _vm.from.id != ''),
      expression: "from.id != null && from.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Modify()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4261442","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtqdFQ/HtqdFq_add.vue
// module id = null
// module chunks = 